var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNoResult(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_8752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.25 68H12.75C5.70775 68 0 62.2923 0 55.25V12.75C0 5.70775 5.70775 0 12.75 0H55.25C62.2923 0 68 5.70775 68 12.75V55.25C68 62.2923 62.2923 68 55.25 68Z",
    fill: "url(#paint0_linear_252_8752)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 28.333C29.3122 28.333 25.5 32.1453 25.5 36.833C25.5 41.5208 29.3122 45.333 34 45.333C38.6877 45.333 42.5 41.5208 42.5 36.833C42.5 32.1453 38.6877 28.333 34 28.333ZM37.8356 38.6648C38.3881 39.2173 38.3881 40.114 37.8356 40.6686C37.5594 40.9449 37.196 41.083 36.8347 41.083C36.4735 41.083 36.1101 40.9449 35.8339 40.6686L34 38.8369L32.1682 40.6686C31.892 40.9449 31.5286 41.083 31.1674 41.083C30.804 41.083 30.4427 40.9449 30.1665 40.6686C29.614 40.1161 29.614 39.2194 30.1665 38.6648L31.9982 36.833L30.1665 35.0013C29.614 34.4488 29.614 33.552 30.1665 32.9974C30.719 32.4428 31.6157 32.4449 32.1704 32.9974L34 34.8313L35.8317 32.9995C36.3842 32.447 37.281 32.447 37.8356 32.9995C38.3903 33.552 38.3881 34.4488 37.8356 35.0034L36.0039 36.8351L37.8356 38.6648Z",
    fill: "url(#paint1_linear_252_8752)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.75 18.417H21.25C18.9061 18.417 17 20.3231 17 22.667V45.3344C17 47.6782 18.9061 49.5844 21.25 49.5844H46.75C49.0939 49.5844 51 47.6782 51 45.3344V22.667C51 20.3231 49.0939 18.417 46.75 18.417ZM46.75 46.7496H21.25C20.468 46.7496 19.8326 46.1142 19.8326 45.3322V25.4996H48.1653V45.3322C48.1674 46.1142 47.532 46.7496 46.75 46.7496Z",
    fill: "url(#paint2_linear_252_8752)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_252_8752",
    x1: -2.5332e-7,
    y1: 34,
    x2: 68,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D39118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_252_8752",
    x1: 34,
    y1: 28.333,
    x2: 34.0142,
    y2: 45.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_252_8752",
    x1: 34,
    y1: 18.417,
    x2: 34.0238,
    y2: 49.5843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_8752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoResult);
export default __webpack_public_path__ + "static/media/icon_no_result.f091c28dc9805cb28e91b47e22345ddb.svg";
export { ForwardRef as ReactComponent };